<div [ngClass]="formFieldConfig.customClass">
    <h4>{{formFieldConfig.displayText}}</h4>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</div>